import type { WeatherLocation, WeatherSnapshot } from '../../utils/Chloromance/types';

type WeatherPanelProps = {
  weather: WeatherSnapshot | null;
  weatherMultiplier: number;
  weatherLocation: WeatherLocation;
  weatherMessage: string;
  weatherLoading: boolean;
  onLocationChange: (location: WeatherLocation) => void;
  onRefresh: () => void;
  onUseCurrentLocation: () => void;
};

export function WeatherPanel({
  weather,
  weatherMultiplier,
  weatherLocation,
  weatherMessage,
  weatherLoading,
  onLocationChange,
  onRefresh,
  onUseCurrentLocation,
}: WeatherPanelProps) {
  return (
    <section className="weather-panel" aria-label="Weather adaptive hydration settings">
      <div className="weather-current">
        <span className={`weather-modifier ${weatherMultiplier !== 1 ? 'is-active' : ''}`}>
          Weather Modifier {weatherMultiplier !== 1 ? 'Active' : 'Idle'}
        </span>
        <div>
          <strong>{weather ? `${Math.round(weather.temperature)}°C · ${weather.condition}` : 'Weather not loaded'}</strong>
          <p>
            {weather
              ? `${weather.reason}; hydration decay is ${Math.round(weather.multiplier * 100)}% of baseline.`
              : 'Set coordinates or use your current location to adapt moisture decay.'}
          </p>
        </div>
      </div>
      <div className="weather-controls">
        <label>
          Latitude
          <input
            inputMode="decimal"
            value={weatherLocation.latitude}
            onChange={(event) => onLocationChange({ ...weatherLocation, latitude: event.target.value })}
          />
        </label>
        <label>
          Longitude
          <input
            inputMode="decimal"
            value={weatherLocation.longitude}
            onChange={(event) => onLocationChange({ ...weatherLocation, longitude: event.target.value })}
          />
        </label>
        <button type="button" onClick={onRefresh} disabled={weatherLoading}>
          {weatherLoading ? 'Checking...' : 'Refresh Weather'}
        </button>
        <button type="button" onClick={onUseCurrentLocation} disabled={weatherLoading}>Use My Location</button>
      </div>
      {weatherMessage && <p className="weather-message">{weatherMessage}</p>}
    </section>
  );
}
